import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  exibePopupLogout: boolean = false;
  returnUrl: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.returnUrl) this.returnUrl = params.returnUrl;
    });

    this.validarExpiracao();
  }

  private validarExpiracao(): void {
    const user = this.authService.LocalStorage.usuarioValido();

    if (!user) {
      this.router.navigate(['/']);
      return;
    }

    const expirado = this.authService.LocalStorage.tokenEstaExpirado(user);

    if (!expirado) {
      this.authService.LocalStorage.desconectar();
      this.router.navigate(['/']);
      return;
    }

    this.desconectar();
  }

  private desconectar(): void {
    this.exibePopupLogout = true;
    this.authService.LocalStorage.desconectar();
  }

  public enviarParaHome(): void {
    this.authService.LocalStorage.desconectar();
    this.router.navigate(['/'], {
      queryParams: { login: 'true', returnUrl: this.returnUrl }
    });
  }


}
